import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const MedicalCategoriesDocument = `
    query MedicalCategories($request: MedicalCategoryRequestInput!) {
  medicalCategories(request: $request) {
    id
    name
    description
    iconUrl
    inflowType
    label
    departmentGroupId
    iconType
    medicalSubCategories {
      id
      name
      searchInflowType
      nonBenefitCategoryId
      nonBenefitItemId
      prescriptionUnit
      keyword
    }
  }
}
    `;
export const useMedicalCategoriesQuery = <
      TData = Types.MedicalCategoriesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.MedicalCategoriesQueryVariables,
      options?: UseQueryOptions<Types.MedicalCategoriesQuery, TError, TData>,
    ) =>
    useQuery<Types.MedicalCategoriesQuery, TError, TData>(
      ['MedicalCategories', variables],
      gqlFetcher<Types.MedicalCategoriesQuery, Types.MedicalCategoriesQueryVariables>(MedicalCategoriesDocument, 'MedicalCategories', variables),
      options
    );

useMedicalCategoriesQuery.getKey = (variables: Types.MedicalCategoriesQueryVariables) => ['MedicalCategories', variables];
;

useMedicalCategoriesQuery.fetcher = (variables: Types.MedicalCategoriesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.MedicalCategoriesQuery, Types.MedicalCategoriesQueryVariables>(MedicalCategoriesDocument, 'MedicalCategories', variables, options);
export const FaceToFaceTreatmentKeywordsDocument = `
    query FaceToFaceTreatmentKeywords {
  faceToFaceTreatmentKeywords {
    id
    name
  }
}
    `;
export const useFaceToFaceTreatmentKeywordsQuery = <
      TData = Types.FaceToFaceTreatmentKeywordsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.FaceToFaceTreatmentKeywordsQueryVariables,
      options?: UseQueryOptions<Types.FaceToFaceTreatmentKeywordsQuery, TError, TData>,
    ) =>
    useQuery<Types.FaceToFaceTreatmentKeywordsQuery, TError, TData>(
      variables === undefined ? ['FaceToFaceTreatmentKeywords'] : ['FaceToFaceTreatmentKeywords', variables],
      gqlFetcher<Types.FaceToFaceTreatmentKeywordsQuery, Types.FaceToFaceTreatmentKeywordsQueryVariables>(FaceToFaceTreatmentKeywordsDocument, 'FaceToFaceTreatmentKeywords', variables),
      options
    );

useFaceToFaceTreatmentKeywordsQuery.getKey = (variables?: Types.FaceToFaceTreatmentKeywordsQueryVariables) => variables === undefined ? ['FaceToFaceTreatmentKeywords'] : ['FaceToFaceTreatmentKeywords', variables];
;

useFaceToFaceTreatmentKeywordsQuery.fetcher = (variables?: Types.FaceToFaceTreatmentKeywordsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.FaceToFaceTreatmentKeywordsQuery, Types.FaceToFaceTreatmentKeywordsQueryVariables>(FaceToFaceTreatmentKeywordsDocument, 'FaceToFaceTreatmentKeywords', variables, options);